import { NotificationStatuses } from "~enums/notificationStatuses";
import type { Notification } from "~types/notification";
import BasePopoverNotificationItem from "./BasePopoverNotificationItem";
import DownloadButton from "./DownloadButton";

type Props = {
  notification: Notification;
  onClick: (notification: Notification) => void;
};

const ExportPopoverNotificationItem = ({ notification, onClick }: Props) => {
  const hasDownload = notification.status === NotificationStatuses.Completed && !!notification.data?.DownloadUrl;
  const actionButton = hasDownload ? <DownloadButton notification={notification} /> : undefined;

  return <BasePopoverNotificationItem notification={notification} onClick={onClick} icon="fa-file-export" actionButton={actionButton} />;
};

export default ExportPopoverNotificationItem;
